// Payslip and payout words still read by the HR employee record (HREmployeeDetail). The period, result and
// employee-payslip vocabularies that lived here were retired with the pages that used them (UI-3A, UI-3B).

const PAYSLIP_STATUS_META = {
  draft: {
    status: "generated",
    label: "Generated",
    description: "The payslip snapshot exists internally for this payroll cycle but is not yet released to the employee.",
  },
  approved: {
    status: "generated",
    label: "Generated",
    description: "The payslip snapshot is finalized for release but is not yet visible to the employee.",
  },
  released: {
    status: "released",
    label: "Released",
    description: "The payslip was released and is now available to the employee.",
  },
  settled: {
    status: "released",
    label: "Released",
    description: "The payslip was released, and this salary has been paid.",
  },
  voided: {
    status: "voided",
    label: "Voided",
    description: "The payslip was voided and should no longer be treated as an active employee statement.",
  },
};

export function getPayrollPayoutStatusMeta({ payslipStatus, financialRecordStatus } = {}) {
  const normalizedPayslipStatus = String(payslipStatus || "").trim().toLowerCase();
  const normalizedFinancialStatus = String(financialRecordStatus || "").trim().toLowerCase();

  if (normalizedPayslipStatus === "voided" || normalizedFinancialStatus === "voided") {
    return {
      status: "voided",
      label: "Voided",
      description: "The payroll payout trail was voided along with the linked payroll record.",
    };
  }

  if (normalizedFinancialStatus === "settled") {
    return {
      status: "paid",
      label: "Paid",
      description: "Finance fully settled the linked payroll obligation, so this salary is already paid.",
    };
  }

  if (normalizedFinancialStatus === "partially_settled") {
    return {
      status: "released",
      label: "Released - Partial Payment",
      description: "The salary was released for payment and Finance has already recorded a partial settlement.",
    };
  }

  if (normalizedPayslipStatus === "released" || normalizedPayslipStatus === "settled") {
    return {
      status: "released",
      label: "Released for Payment",
      description: "The salary was released for employee visibility and is now pending full Finance settlement.",
    };
  }

  return {
    status: "pending",
    label: "Pending Payout",
    description: "Salary has been calculated, but it has not yet reached the released-for-payment or paid stage.",
  };
}

export function getPayslipStatusMeta(status) {
  const normalized = String(status || "").trim().toLowerCase();
  return PAYSLIP_STATUS_META[normalized] || PAYSLIP_STATUS_META.draft;
}
